import React from "react";
import { createPortal } from "react-dom";
import styles from "./ota-configurations.module.scss";
import OTAUpdateCard from "../../molecules/ota-update-card/ota-update-card";
import OTAConfigurationHistory from "../ota-configuration-history/ota-configuration-history";
import OtaLoader from "@src/components/molecules/ota-loader/ota-loader";
import OtaConfigurationUploadModal from "../modals/ota-configuration-upload-modal/ota-configuration-upload-modal";
import OtaConfigurationInstallModal from "../modals/ota-configuration-install-modal/ota-configuration-install-modal";
import OtaDownloadModal from "../modals/ota-download-modal/ota-download-modal";
import OtaConfigurationBackupInstallModal from "../modals/ota-configuration-backup-install-modal/ota-configuration-backup-install-modal";
import { OtaConfigurationDrawerModal } from "../modals/ota-configuration-drawer-modal/ota-configuration-drawer-modal";
import { OtaConfigurationBackupDrawerModal } from "../modals/ota-configuration-backup-drawer-modal/ota-configuration-backup-drawer-modal";
import { useOtaConfigurations } from "./use-ota-configurations";

const cssClassName = "ota-configurations";

const OTAConfigurations = () => {
  const {
    modalRoot,
    configurationValues,
    setConfigurationValues,
    backupInputValues,
    setBackupInputValues,
    activeOTAHistoryTab,
    setActiveOTAHistoryTab,
    configurations,
    backups,
    activeList,
    isLoading,
    installUpdateId,
    setInstallUpdateId,
    showOtaConfigurationDrawerModal,
    showConfigurationUploadModal,
    showConfigurationInstallModal,
    showOtaConfigurationBackupDrawerModal,
    showOtaDownloadModal,
    showConfigurationBackupInstallModal,
    fetchConfigurations,
    fetchBackups,
    closeConfigurationUploadModal,
    onInstallStarted,
    handleCloseOtaDownloadModal,
    setIsConfigurationLoading,
    setIsBackupLoading,
  } = useOtaConfigurations();

  return (
    <div className={styles[cssClassName]}>
      {isLoading ? (
        <OtaLoader />
      ) : (
        <>
          <OTAUpdateCard
            cardData={activeList[0]}
            onInstallStarted={onInstallStarted}
            activeOTAHistoryTab={activeOTAHistoryTab}
            activeInstallationData={null}
          />
          <OTAConfigurationHistory
            activeOTAHistoryTab={activeOTAHistoryTab}
            setActiveOTAHistoryTab={setActiveOTAHistoryTab}
            configurations={configurations}
            backups={backups}
            onInstallStarted={onInstallStarted}
            fetchMainList={fetchConfigurations}
            fetchBackups={fetchBackups}
            setIsConfigurationLoading={setIsConfigurationLoading}
            setIsBackupLoading={setIsBackupLoading}
          />
        </>
      )}

      {modalRoot &&
        showOtaConfigurationDrawerModal &&
        createPortal(
          <OtaConfigurationDrawerModal
            inputValues={configurationValues}
            setInputValues={setConfigurationValues}
          />,
          modalRoot,
        )}

      {showConfigurationUploadModal && (
        <OtaConfigurationUploadModal
          inputValues={configurationValues}
          onClose={closeConfigurationUploadModal}
        />
      )}

      {showConfigurationInstallModal && (
        <OtaConfigurationInstallModal
          data={activeList[0]}
          installUpdateId={installUpdateId}
          setInstallUpdateId={setInstallUpdateId}
        />
      )}

      {showConfigurationBackupInstallModal && (
        <OtaConfigurationBackupInstallModal
          data={activeList[0]}
          installUpdateId={installUpdateId}
          setInstallUpdateId={setInstallUpdateId}
        />
      )}

      {modalRoot &&
        showOtaConfigurationBackupDrawerModal &&
        createPortal(
          <OtaConfigurationBackupDrawerModal
            inputValues={backupInputValues}
            setInputValues={setBackupInputValues}
            fetchBackups={fetchBackups}
          />,
          modalRoot,
        )}

      {showOtaDownloadModal && (
        <OtaDownloadModal onClose={handleCloseOtaDownloadModal} />
      )}
    </div>
  );
};

export default OTAConfigurations;
